module.exports = __webpack_public_path__ + "img/CUP_LOCAL.e74bebbe.svg";